import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from './auth.service';
import { Role } from '../dashboard/profile/models/role';

@Injectable()
export class SmeGuard implements CanActivate {
  constructor(private readonly authService: AuthService) {}

  canActivate(): boolean {
    return this.authService.handleCanActivateFor(Array.of(Role.SME, Role.SMEViewer), false);
  }
}
